document.addEventListener('DOMContentLoaded', function () {
  class LocationModal extends HTMLElement {
    constructor() {
      super();

      /** @type {string | null} */
      this.triggerList = null;

      /** @type {number | null} */
      this.delay = null;

      /** @type {NodeListOf<HTMLElement> | []} */
      this.closeElements = [];

      /** @type {string | null} */
      this.handle = null;

      /** @type {function(): void} */
      this.boundCloseModal = this.closeModal.bind(this);
    }

    async connectedCallback() {
      this.closeElements = this.querySelectorAll('[data-close-modal]');
      this.triggerList = this.dataset.locationTrigger;
      this.delay = Number(this.dataset.appearDelay) || 3_000;

      this.handle = await this.get_current_location();

      const matchedLocation = !this.isMatchLocation(this.handle);
      const isClosedFromUser = this.storageUtils().get('_location_modal') === 'true';

      if (matchedLocation && !isClosedFromUser) setTimeout(this.openModal.bind(this), this.delay);

      this.closeElements.forEach((element) => element.addEventListener('click', this.boundCloseModal));
    }

    disconnectedCallback() {
      this.closeElements.forEach((element) => element.removeEventListener('click', this.boundCloseModal));
    }

    /**
     * Get the user's current country from the Shopify API.
     *
     * @returns {Promise<string>} The country handle, or an empty string
     * if the request fails.
     */
    async get_current_location() {
      try {
        const data = await (await fetch('/browsing_context_suggestions.json')).json();
        return String(data.detected_values.country_name).toLocaleLowerCase().replace('-', ' ');
      } catch (error) {
        console.log(error);
        return '';
      }
    }

    /**
     * Check whether the user's country is in the trigger list.
     *
     * @param {string} handle Country handle.
     * @returns {boolean} True if the country is in the list.
     */
    isMatchLocation(handle) {
      if (!handle) return false;

      return this.parseListToArray().includes(handle);
    }

    /**
     * Change the trigger list from a string to an array.
     *
     * @returns {Array<string>} An array of country handles.
     */
    parseListToArray() {
      try {
        return this.triggerList.split(',');
      } catch (error) {
        console.log(error);
        return [];
      }
    }

    /**
     * Create helper functions for working with local storage.
     *
     * @returns {{
     *   get: function(string): string,
     *   set: function(string, string): void
     * }} Functions for getting and saving values.
     */
    storageUtils() {
      return {
        get: (key) => localStorage.getItem(key) || 'false',
        set: (key, value) => localStorage.setItem(key, value),
      };
    }

    /**
     * Update value according to param.
     *
     * @param {boolean} shouldOpen True to open the modal.
     */
    toggleValues(shouldOpen = false) {
      document.body.classList.toggle('overflow-hidden', shouldOpen);
      this.toggleAttribute('open', shouldOpen);
    }

    /**
     * Open the location modal.
     */
    openModal() {
      this.toggleValues(true);
    }

    /**
     * Close the location modal.
     */
    closeModal() {
      this.toggleValues(false);
      this.storageUtils().set('_location_modal', 'true');
    }
  }

  if (!customElements.get('location-modal')) {
    customElements.define('location-modal', LocationModal);
  }
});
